(() => {
  let intervalId = null;
  let deadline = null;

  function getEls() {
    const modal = document.querySelector('.nextdev--product-upsell-modal');
    if (!modal) return {};

    const countdown = modal.querySelector('.nextdev--product-upsell-modal--countdown-timer');
    const cancelBtn = modal.querySelector('button[name="cancel"]');
    const continueToCartBtn = modal.querySelector('button[name="continue_to_cart"]');
    const mm = countdown?.querySelector('.nextdev--product-upsell-modal--countdown-timer-minutes');
    const ss = countdown?.querySelector('.nextdev--product-upsell-modal--countdown-timer-seconds');
    const swiper = modal.querySelector('.swiper');

    return { modal, countdown, cancelBtn, mm, ss, swiper };
  }

  const pad2 = (n) => String(n).padStart(2, '0');

  function updateTimerDigit(el, newValue) {
    if (el && el.innerText !== newValue) {
      el.innerText = newValue;
      el.classList.remove('animate-change');

      void el.offsetWidth;
      el.classList.add('animate-change');
    }
  }

  function hideModal() {
    const { modal, cancelBtn, continueToCartBtn } = getEls();
    cancelBtn?.click();
    continueToCartBtn?.click();

    modal.classList.add('hide');
    document.body.classList.remove('overflow-hidden');
  }

  function tick() {
    const { mm, ss } = getEls();
    const now = Date.now();
    const timeLeft = Math.max(0, deadline - now);

    if (timeLeft === 0) {
      clearInterval(intervalId);
      intervalId = null;
      hideModal();
      return;
    }

    const mins = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
    const secs = Math.floor((timeLeft % (1000 * 60)) / 1000);

    if (mm) mm.innerText = pad2(mins);
    updateTimerDigit(ss, pad2(secs));
  }

  function start({ durationMs = 10 * 60 * 1000 } = {}) {
    const { modal, countdown, swiper } = getEls();
    if (!countdown) return;

    deadline = Date.now() + durationMs;
    if (intervalId) clearInterval(intervalId);

    tick();
    intervalId = setInterval(tick, 1000);

    document.body.classList.add('overflow-hidden');
    modal.classList.remove('hide');

    if (!swiper) return;

    new Swiper(swiper, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      slidesPerGroup: 1,
      direction: 'vertical',
          
      mousewheel: {
        forceToAxis: true
      },
    
      breakpoints: {
        750: {
          spaceBetween: 10,
          direction: 'horizontal',
        }
      }
    });
  }

  function stop() {
    if (intervalId) {
      clearInterval(intervalId);
      intervalId = null;
    }
  }

  window.ProductUpsellModalCountdown = { start, stop, isRunning: () => !!intervalId };

  document.addEventListener('DOMContentLoaded', function() {
    const variantSelectors = document.querySelectorAll('.variant-selector');

    if (variantSelectors.length > 0) {
      variantSelectors.forEach(selector => {
        selector.addEventListener('change', function(e) {
          const variantId = parseInt(e.target.value, 10);
          const item = e.target.closest('.nextdev--product-upsell-modal--products__item');
          const selectedOption = e.target.options[e.target.selectedIndex];
          const price = selectedOption.dataset.price;
          const comparePrice = selectedOption.dataset.comparePrice;
          const save = selectedOption.dataset.save;
          const image = selectedOption.dataset.image;

          const priceElement = item.querySelector('.nextdev--product-upsell-modal--products__item--price span:not(.compare-at-price):not(.save)');
          const comparePriceElement = item.querySelector('.nextdev--product-upsell-modal--products__item--price .compare-at-price');
          const saveElement = item.querySelector('.nextdev--product-upsell-modal--products__item--price .save');
          const buttonElement = item.querySelector('.nextdev--product-upsell-modal--products__item product-form button[type="submit"]');

          buttonElement.disabled = !variantId || selectedOption.disabled;
          
          if (priceElement && price) priceElement.textContent = price;
          if (comparePriceElement && comparePrice) comparePriceElement.textContent = comparePrice;
          if (saveElement && save) saveElement.textContent = `Save ${save}`;
          if (image) {
            const imageElement = item.querySelector('.nextdev--product-upsell-modal--products__item--image img');
            imageElement.removeAttribute('srcset');
            imageElement.src = image;
            imageElement.alt = selectedOption.dataset.imageAlt || '';
          }
        });
      });
    }
  });
})();
